/**
 * 订阅Bar
 * 
 * @Author: Focci
 * @Date: 2023-07-20 14:46:39
 * @Last Modified by: Focci
 * @Last Modified time: 2023-07-20 14:46:39
 */

'use client'

// import PropTypes from 'prop-types'
import SVGAddTag from '@img/add-tag.svg'
import useDialog from '@hook/useDialog'
import useLogin from '@hook/useLogin'
import { ButtonBase } from '@comp/material'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'
import { checkSubcribe } from './lib'
import SubcribeFilterItems from './SubcribeFilterItems'
import SubcribeContent from './SubcribeContent'

export default function SubcribeBar({
  type = '',
  searchParam = {}
}) {
  const ts = useTranslations('search')
  const tl = useTranslations('live')

  const enableSubcribe = checkSubcribe(type)
  const { openDialog, closeDialog, Dialog } = useDialog()
  const [subcribeOptions, setSubcribeOptions] = useState(searchParam)
  const { isLogin, openSigninDialog } = useLogin()
  const [isSubcribed, setIsSubcribed] = useState(false)

  const handleOpenDialog = useCallback(() => {
    if(!isLogin) {
      return openSigninDialog()
    }
    return openDialog()
  }, [isLogin, openDialog, openSigninDialog])

  const handleSuccess = useCallback(() => {
    closeDialog()
    setIsSubcribed(true)
  }, [closeDialog])

  return (
    <div className="text-center my-8">
      <div className="text-f.9 font-medium relative">
        <span className="py-2 px-4 bg-white relative z-1">
          {ts('nomoreProperty')}
        </span>
        <span 
          className="
            absolute left-0 right-0 border-t border-solid
            top-1/2
          " 
        />
      </div>
      {enableSubcribe && (
        <>
          <div className="text-f.7 mt-2">
            {ts('subcribeIntroduce')}
          </div>
          <div className="bg-[#F2F5F7] p-2 mt-4 flex items-center flex-wrap gap-2">
            <SubcribeFilterItems 
              type={type}
              searchParam={searchParam}
              onChange={(v) => setSubcribeOptions(v)}
            />
            <ButtonBase 
              className="rounded-full"
              disabled={isSubcribed}
              onClick={handleOpenDialog}
            >
              <div 
                className="
                  flex items-center gap-1 text-primary border border-primary h-6 
                  px-3 rounded-full
                "
              >
                <SVGAddTag />
                <span>{isSubcribed ? tl('subscribed') : ts('subcribeFilter')}</span>
              </div>
            </ButtonBase>
          </div>
        </>
      )}
      <Dialog title={ts('subcribeFilter')}>
        <SubcribeContent
          type={type}
          options={subcribeOptions}
          onSuccess={handleSuccess}
        />
      </Dialog>
    </div>
  )
}

// SubcribeBar.propTypes = {
//   className: PropTypes.string,
// }
